exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.leadership[data-v-3fb6c8ea] {\n    text-align: center !important;\n}\n", ""]);

// exports
